<ng-container *ngFor="let post of posts">
  <app-brand-campaign-posts-list-item
    [campaign]="campaign"
    [type]="type"
    [post]="post"
  >
  </app-brand-campaign-posts-list-item>
</ng-container>
<div class="no-posts" *ngIf="posts.length === 0">
  {{ "campaign.postList.noPosts" | translate }}
</div>
